import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { whenGtmReady } from "./gtm";

/**
 * Pushes a virtual page view when the SPA route changes (align payload with your GTM container).
 * Waits for `gtm.js` to finish loading so events are not queued ahead of container readiness.
 */
export function GtmRouteListener() {
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    void whenGtmReady().then(() => {
      if (cancelled) return;
      window.dataLayer?.push({
        event: "virtualPageview",
        page_path: location.pathname + location.search,
      });
    });
    return () => {
      cancelled = true;
    };
  }, [location.pathname, location.search]);

  return null;
}
